import { z } from 'zod';
/**
 * Dialer events pushed over SSE by the backend DialerEventsService.
 *
 * Subscription URL: GET /api/dialer/events?agentEmail=...
 * Each event is a standalone SSE message; the frontend uses `event: <name>`
 * + `data: <json>` to demultiplex.
 *
 * These payloads are the source of truth for the frontend useDialerEvents
 * hook (REFACTORING_FRONTEND_PLAN.md §12).
 */
export const DialerEventNameSchema = z.enum([
    'call:initiated',
    'call:ringing',
    'call:answered',
    'call:voicemail',
    'call:completed',
]);
export const DialerEventBaseSchema = z.object({
    callId: z.string(),
});
export const CallInitiatedPayloadSchema = DialerEventBaseSchema.extend({
    prospectPhone: z.string(),
});
export const CallRingingPayloadSchema = DialerEventBaseSchema;
export const CallAnsweredPayloadSchema = DialerEventBaseSchema;
export const CallVoicemailPayloadSchema = DialerEventBaseSchema;
export const CallCompletedPayloadSchema = DialerEventBaseSchema;
/** Discriminated union used by the frontend hook to dispatch on type. */
export const DialerEventSchema = z.discriminatedUnion('type', [
    z.object({ type: z.literal('call:initiated'), callId: z.string(), prospectPhone: z.string() }),
    z.object({ type: z.literal('call:ringing'), callId: z.string() }),
    z.object({ type: z.literal('call:answered'), callId: z.string() }),
    z.object({ type: z.literal('call:voicemail'), callId: z.string() }),
    z.object({ type: z.literal('call:completed'), callId: z.string() }),
]);
//# sourceMappingURL=dialer-event.schema.js.map